/* Prop & Piston Hangar theme scripts */
(function () {
  'use strict';
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Parts finder (header + hero) ---------- */
  function initPartsFinder(form) {
    var make = form.querySelector('[data-pf-make]');
    var model = form.querySelector('[data-pf-model]');
    var part = form.querySelector('[data-pf-part]');
    var year = form.querySelector('[data-pf-year]');
    var q = form.querySelector('[data-pf-query]');
    var browse = form.querySelector('[data-pf-browse]');
    var defaultBrowse = browse ? browse.getAttribute('href') : '';
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem('pp_vehicle') || '{}'); } catch (e) { saved = {}; }

    function fillModels(selected) {
      var opt = make.options[make.selectedIndex];
      model.innerHTML = '<option value="">All ' + (make.value || '') + ' models</option>';
      if (!opt || !opt.value) {
        model.disabled = true;
        if (browse) { browse.setAttribute('href', defaultBrowse); browse.textContent = 'All performance parts'; }
        return;
      }
      (opt.getAttribute('data-models') || '').split(',').forEach(function (m) {
        m = m.trim(); if (!m) return;
        var o = document.createElement('option');
        o.value = m; o.textContent = m;
        if (selected && selected === m) o.selected = true;
        model.appendChild(o);
      });
      model.disabled = false;
      if (browse) { browse.setAttribute('href', opt.getAttribute('data-url')); browse.textContent = 'All ' + opt.value + ' parts'; }
    }

    make.addEventListener('change', function () { fillModels(); });
    if (saved.make) {
      make.value = saved.make;
      fillModels(saved.model);
      if (saved.year && year) year.value = saved.year;
    }

    form.addEventListener('submit', function (e) {
      if (!make.value) { e.preventDefault(); make.focus(); return; }
      var terms = [make.value];
      if (model.value) terms.push(model.value);
      if (part && part.value) terms.push(part.value);
      q.value = terms.join(' ');
      try { localStorage.setItem('pp_vehicle', JSON.stringify({ make: make.value, model: model.value, year: year ? year.value : '' })); } catch (err) {}
      if (!year || !year.value) year && year.removeAttribute('name');
    });
  }
  $$('[data-parts-finder]').forEach(initPartsFinder);

  /* ---------- Search results: hide parts that don't fit the chosen year ---------- */
  (function yearFilter() {
    var grid = document.querySelector('[data-year-filter]');
    if (!grid) return;
    var y = parseInt(new URLSearchParams(location.search).get('year'), 10);
    if (!y) return;
    var hidden = 0;
    $$('[data-title]', grid).forEach(function (el) {
      var t = el.getAttribute('data-title');
      var m = t.match(/((?:19|20)\d{2})\s*[-–+]\s*((?:19|20)\d{2})?/);
      if (!m) return;
      var from = parseInt(m[1], 10), to = m[2] ? parseInt(m[2], 10) : 2100;
      if (y < from || y > to) { el.hidden = true; hidden++; }
    });
    var note = document.querySelector('[data-year-note]');
    if (note) {
      note.hidden = false;
      note.querySelector('[data-year-value]').textContent = y;
      note.querySelector('[data-year-hidden]').textContent = hidden;
    }
  })();

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var tabs = $$('[role="tab"]', wrap);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on);
          document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
        });
      });
    });
  });

  /* ---------- State filter (hub + home) ---------- */
  $$('[data-state-filter]').forEach(function (input) {
    var list = document.getElementById(input.getAttribute('aria-controls'));
    input.addEventListener('input', function () {
      var v = input.value.trim().toLowerCase();
      $$('[data-state]', list).forEach(function (el) {
        el.hidden = v && el.getAttribute('data-state').indexOf(v) === -1;
      });
    });
  });

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var slides = $$('.gallery__slide', g);
    var thumbs = $$('.gallery__thumb', g);
    var idx = 0;
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); s.setAttribute('aria-hidden', n !== idx); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = g.querySelector('.gallery__nav--prev'), next = g.querySelector('.gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    var x0 = null, main = g.querySelector('.gallery__main');
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    g.showMediaId = function (id) {
      slides.forEach(function (s, n) { if (s.getAttribute('data-media-id') === String(id)) show(n); });
    };
  });

  /* ---------- Variant picker ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[name="id"]');
    var btn = form.querySelector('[data-add]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var gallery = document.querySelector('[data-gallery]');
    var money = function (c) { return (window.ppMoney || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')); };

    function current() {
      var opts = $$('[data-option]', form).map(function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function update() {
      var v = current();
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to cart' : 'Sold out';
      $$('[data-option-value]', form).forEach(function (b) {
        var i = parseInt(b.getAttribute('data-index'), 10);
        b.textContent = v.options[i];
      });
      if (priceEl) {
        priceEl.querySelector('.price__now').textContent = money(v.price);
        var was = priceEl.querySelector('.price__was');
        if (v.compare_at_price > v.price) {
          if (!was) { was = document.createElement('s'); was.className = 'price__was'; priceEl.appendChild(was); }
          was.textContent = money(v.compare_at_price); priceEl.classList.add('price--sale');
        } else if (was) { was.remove(); priceEl.classList.remove('price--sale'); }
      }
      if (v.featured_media && gallery && gallery.showMediaId) gallery.showMediaId(v.featured_media.id);
      var url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
      $$('[data-sticky-price]').forEach(function (el) { el.textContent = money(v.price); });
    }
    form.addEventListener('change', function (e) { if (e.target.closest('[data-option]')) update(); });

    var qty = form.querySelector('[name="quantity"]');
    $$('[data-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
      });
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var msg = form.querySelector('[data-msg]');
      btn.disabled = true; var label = btn.textContent; btn.textContent = 'Adding...';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qty.value, 10) || 1 }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || 'Could not add to cart');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
          if (window.PPCart && PPCart.enabled) { PPCart.refresh(); PPCart.open(true); if (msg) msg.textContent = ''; }
          else if (msg) msg.innerHTML = 'Added. <a href="/cart">View cart and check out &rarr;</a>';
          btn.textContent = 'Added'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
        })
        .catch(function (err) { if (msg) msg.textContent = err.message; btn.textContent = label; btn.disabled = false; });
    });
  });

  /* ---------- Sticky buy bar ---------- */
  var sticky = document.querySelector('[data-sticky-buy]');
  var anchor = document.querySelector('[data-add]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }).observe(anchor);
    sticky.querySelector('button').addEventListener('click', function () { anchor.click(); });
  }

  /* ---------- Close open header popovers on outside click ---------- */
  document.addEventListener('click', function (e) {
    $$('.search-pop[open], .mobile-nav[open], .facets details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ---------- Collapse parts finder by default on phones ---------- */
  var pt = document.querySelector('[data-parts-toggle]');
  if (pt && window.matchMedia('(max-width: 760px)').matches) pt.removeAttribute('open');
})();
